var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20965 2.26647C8.64435 1.79551 8.8617 1.56003 9.09264 1.42267C9.6499 1.09124 10.3361 1.08093 10.9027 1.39548C11.1375 1.52584 11.3615 1.7547 11.8096 2.2124C12.2576 2.67011 12.4817 2.89896 12.6093 3.13883C12.9172 3.71761 12.9071 4.41859 12.5827 4.98787C12.4482 5.2238 12.2177 5.44583 11.7567 5.88988L6.27117 11.1733C5.3975 12.0148 4.96066 12.4356 4.41469 12.6488C3.86873 12.8621 3.26852 12.8464 2.06812 12.815L1.9048 12.8107C1.53935 12.8012 1.35663 12.7964 1.25042 12.6758C1.1442 12.5553 1.1587 12.3691 1.1877 11.9969L1.20345 11.7948C1.28508 10.747 1.32589 10.2232 1.53049 9.75224C1.73508 9.28132 2.088 8.899 2.79383 8.13425L8.20965 2.26647Z",
    stroke: "#141B34",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58334 2.33337L11.6667 6.41671",
    stroke: "#141B34",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16666 12.8334H12.8333",
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.ec895bf9d3eaff685b8e8eeca1331f1c.svg";
export { ForwardRef as ReactComponent };